export default () => {
  window.documentViewer.getAnnotationHistoryManager().undo();
};
